/**
 * Константы для системы предзагрузки моделей
 */

export const LOAD_TIMEOUTS = {
    CRITICAL: 15000,
    ADDITIONAL: 60000,
};

export const LOAD_PRIORITIES = {
    CRITICAL: 'critical',
    ADDITIONAL: 'additional'
};
